import { StatusCodes } from "http-status-codes";
import { request } from "../../api";
import { headers } from "../../../../config/config";
import { MESSAGE } from "../../../../constants/api/message";
import { AUTHORIZATION } from "../../../../constants/api/auth";
import { employeeAndAssignedLocationsQueryTypes } from "../../../../@types/paycheck.types";

const { get } = request;
const { Authorization, Bearer } = AUTHORIZATION;

const initialRoute = "pages";

export const getEmployeeAndAssignedLocations = async (
	employeeAndAssignedLocationsQuery: employeeAndAssignedLocationsQueryTypes
) => {
	try {
		const endpoint = `${initialRoute}/get-employee-and-assigned-locations`;
		const token = localStorage.getItem("@jwt");
		const response = await get(
			endpoint,
			{
				...headers,
				[Authorization]: `${Bearer} ${token}`
			},
			employeeAndAssignedLocationsQuery
		);

		if (response) {
			const {
				data: { message }
			} = response;
			if (message === MESSAGE.get.succ) {
				const {
					data: { result }
				} = response;
				return result;
			}
		}
		throw new Error();
	} catch (error: any) {
		if (error.response.status === StatusCodes.BAD_REQUEST) {
			const { message } = error.response.data;

			if (message === "Employee SSN is required!") {
				alert("Employee SSN is required!");
			} else if (message === "Please enter a valid SSN!") {
				alert("Please enter a valid SSN!");
			} else if (message === "Employee doesnot exists!") {
				alert("Employee doesnot exists!");
			} else if (message === "No Location has assigned!") {
				alert("No Location has assigned!");
			} else if (message === MESSAGE.post.fail) {
				alert("Failed to get members!");
			} else alert("Other Errors of Status Code 400");
		} else {
			throw error;
		}
	}
};
